import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { XIconAi } from '../../../../../react/features/base/icons/svg';
import ToolboxItem
    from '../../../../../react/features/base/toolbox/components/ToolboxItem.web';

const XbeesTranscriptionButton = () => {
    const { t } = useTranslation();
    const {
        isXbeesTranscriptionButtonVisible,
        isXbeesTranscriptionButtonToggled
    } = useSelector(state => state['xbees/buttons']);
    const onClick = () => {
        APP.xBeesEvents.toggleTranscription(isXbeesTranscriptionButtonToggled, true);

        document.activeElement.blur();
    };

    return (
        <div className={'button-circle button-xbees-transcription'} style={{
            visibility: isXbeesTranscriptionButtonVisible ? 'visible' : 'hidden'
        }}>
            <ToolboxItem
                accessibilityLabel={t('transcribing.subtitles')}
                icon={XIconAi}
                tooltipPosition={'left'}
                onClick={onClick}
                toggled={isXbeesTranscriptionButtonToggled}
                tooltip={t('transcribing.subtitles')} />
        </div>
    );
};

export default XbeesTranscriptionButton;
